
import { css } from 'lit';
export default css`
.location-app {
  height: 100%;
  width: 100%;
}

  .location-app__content {
  display: flex;
}

  .location-app__content {
  flex-direction: column;
}

  @media (min-width: 640px) {

  .location-app__content {
    padding-top: 0px;
  }
}

  @media (min-width: 1024px) {

  .location-app__content {
    position: relative;
  }
}

  @media (min-width: 1024px) {

  .location-app__content {
    height: auto;
  }
}

  @media (min-width: 1024px) {

  .location-app__content {
    flex-direction: row;
  }
}

  @media (min-width: 1024px) {

  .location-app__screen-toggle {
    display: none;
  }
}

  .location-app__fakecontrols {
    height: 84px;
  }

  .location-app__fakecontrols--hidden {
  display: none;
}

  @media (max-width: 1023px) {

  .location-app__filters {
    position: fixed;
  }
}

  @media (max-width: 1023px) {

  .location-app__filters {
    top: 0px;
  }
}

  @media (max-width: 1023px) {

  .location-app__filters {
    left: 0px;
  }
}

  @media (max-width: 1023px) {

  .location-app__filters {
    z-index: 9999;
  }
}

  @media (max-width: 1023px) {

  .location-app__filters {
    height: 100%;
  }
}

  @media (max-width: 1023px) {

  .location-app__filters {
    width: 100%;
  }
}

  @media (max-width: 1023px) {

  .location-app__filters {
    overflow: auto;
  }
}

  @media (max-width: 1023px) {

  .location-app__filters {
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  }
}

  @media (max-width: 1023px) {

  .location-app__filters {
    padding: 1.5rem;
  }
}

  .location-app__filters--hidden {
  display: none;
}

  @media (min-width: 1024px) {

  .location-app__filters {
      display: block !important;
      width: 35%;
      padding-top: 3.5rem;
      padding-right: 2rem
  }
    }

  @media (min-width: 1200px) {

  .location-app__filters {
      padding-right: 4rem
  }
    }

  @media (min-width: 1366px) {

  .location-app__filters {
      padding-right: 7rem
  }
    }

  .location-app__filters-item {
  display: flex;
}

  .location-app__filters-item {
  justify-content: space-between;
}

  .location-app__filters-item {
  font-size: 1rem;
}

  .location-app__filters-item {
  font-weight: 400;
}

  .location-app__filters-item {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

  .location-app__filters-item {
      padding: 20px 0;
      border-bottom: 1px solid #C691E7;
    }

  /* this color is not on the outline.config.css file */

  .location-app__filters-item:first-child {
        border-top: 1px solid #C691E7;
        margin-top: 4px;
      }

  .location-app__filters-arrow-icon {
  height: 1rem;
}

  .location-app__filters-arrow-icon {
  width: 1rem;
}

  .location-app__filters-close {
  display: flex;
}

  .location-app__filters-close {
  width: 100%;
}

  .location-app__filters-close {
  align-items: center;
}

  .location-app__filters-close {
  justify-content: flex-start;
}

  .location-app__filters-close {
  padding-bottom: 1.5rem;
}

  .location-app__filters-close {
  font-size: 1.125rem;
}

  .location-app__filters-close {
  font-weight: 700;
}

  @media (min-width: 1024px) {

  .location-app__filters-close {
    display: none;
  }
}

  .location-app__filters-close {
      border-bottom: 1px solid #C691E7  /* this color is not on the outline.config.css file */;
    }

  .location-app__filters-close--small-icon {
  margin-right: 0.75rem;
}

  .location-app__filters-close--small-icon {
  height: 1rem;
}

  .location-app__filters-close--small-icon {
  width: 1rem;
}

  .location-app__filters-close--icon {
  margin-left: auto;
}

  .location-app__filters-close--icon {
  width: 1.25rem;
}

  .location-app__filters-close--icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .location-app__filters-close--bottom {
  width: auto;
}

  .location-app__filters-close--bottom {
  border-width: 0px;
}

  .location-app__filters-close--bottom {
  padding-bottom: 0px;
}

  .location-app__filters-close--bottom {
  font-size: 1rem;
}

  .location-app__filters-close--bottom {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .location-app__filters-see-all {
  margin-top: 0.5rem;
}

  .location-app__filters-see-all {
  display: flex;
}

  .location-app__filters-see-all {
  width: 100%;
}

  .location-app__filters-see-all {
  align-items: center;
}

  .location-app__filters-see-all {
  justify-content: flex-end;
}

  .location-app__filters-see-all {
  padding-bottom: 1.5rem;
}

  .location-app__filters-see-all {
  font-size: 1.125rem;
}

  .location-app__filters-see-all {
  font-weight: 700;
}

  .location-app__filters-see-all {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .location-app__filters-see-all .splide__arrow--icon {
        width: 1rem;
        margin-left: .5rem;
      }

  .location-app__controls {
  position: fixed;
}

  .location-app__controls {
  bottom: 0px;
}

  .location-app__controls {
  left: 0px;
}

  .location-app__controls {
  right: 0px;
}

  .location-app__controls {
  display: flex;
}

  .location-app__controls {
  display: none;
}

  .location-app__controls {
  align-items: center;
}

  .location-app__controls {
  justify-content: flex-end;
}

  .location-app__controls {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .location-app__controls {
  padding: 1rem;
}

  @media (min-width: 1024px) {

  .location-app__controls {
    display: none;
  }
}

  .location-app__controls--static {
  position: static;
}

  .location-app__controls--static {
  padding-left: 0px;
  padding-right: 0px;
}

  .location-app__controls--static .location-app__filters-close--bottom {
  margin-left: 1rem;
}

  .location-app__map {
  position: absolute;
}

  .location-app__map {
  left: 0px;
}

  .location-app__map {
  right: 0px;
}

  .location-app__map {
  width: 100%;
}

  .location-app__map {
  flex-grow: 0;
}

  .location-app__map {
    bottom: 80px;
    width: 100vw;
    height: 60%;
    --hf-location-map-height: 60vh;
  }

  .location-app__map--hidden {
  display: none;
}

  .location-app__map--hidden {
  width: 0px;
}

  @media (min-width: 1024px) {

  .location-app__map--hidden {
    display: block;
  }
}

  @media (min-width: 1024px) {

  .location-app__map {
    position: static;
  }
}

  @media (min-width: 1024px) {

  .location-app__map {
    margin-left: 0px;
    margin-right: 0px;
  }
}

  @media (min-width: 1024px) {

  .location-app__map {
    margin-bottom: 0px;
  }
}

  @media (min-width: 1024px) {

  .location-app__map {
    display: block;
  }
}

  @media (min-width: 1024px) {

  .location-app__map {
    width: 100%;
  }
}

  @media (min-width: 1024px) {

  .location-app__map {
      --hf-location-map-height: 100vh;
      width: 40%
  }

      .location-app__map--hidden {
        width: 40%;
      }
    }

  .location-app__list {
  display: flex;
}

  .location-app__list {
  width: 100%;
}

  .location-app__list {
  flex-direction: column;
}

  .location-app__list {
    margin-top: 3.5rem;
  }

  .location-app__list--hidden {
  display: none;
}

  @media (min-width: 1024px) {

  .location-app__list--hidden {
    display: block;
  }
}

  @media (min-width: 1024px) {

  .location-app__list {
      width: 65%
  }
    }

  .location-app__list-heading {
  display: flex;
}

  .location-app__list-heading {
  align-items: center;
}

  .location-app__list-heading {
  justify-content: space-between;
}

  .location-app__list-heading .location-list__card-count {
        text-transform: uppercase;
      }

  .location-app__filter-button {
  display: flex;
}

  .location-app__filter-button {
  display: inline-flex;
}

  .location-app__filter-button {
  align-items: center;
}

  .location-app__filter-button {
  justify-content: center;
}

  .location-app__filter-button {
  border-radius: 0.25rem;
}

  .location-app__filter-button {
  border-radius: 1.5rem;
}

  .location-app__filter-button {
  border-width: 2px;
}

  .location-app__filter-button {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

  .location-app__filter-button {
  padding: 0.5rem;
}

  .location-app__filter-button {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

  .location-app__filter-button {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

  .location-app__filter-button {
  font-size: 0.875rem;
}

  .location-app__filter-button {
  font-size: 1.125rem;
}

  .location-app__filter-button {
  font-weight: 700;
}

  .location-app__filter-button {
  font-weight: 400;
}

  .location-app__filter-button {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .location-app__filter-button--icon {
  margin-right: 0.5rem;
}

  .location-app__filter-button--icon {
  margin-top: -2px;
}

  .location-app__filter-button--icon {
      width: 14px;
    }

  .location-app__filter-button--top {
  margin-right: 1.5rem;
}

  .location-app__filter-button--top {
  display: none;
}

  .location-app__filter-button--top {
      min-width: 115px;
    }

  @media (min-width: 1024px) {

  .location-app__filter-button--top {
    display: flex;
  }
}

  .location-app__filter-screen {
  position: absolute;
}

  .location-app__filter-screen {
  left: 0px;
  right: 0px;
}

  .location-app__filter-screen {
  z-index: 10;
}

  .location-app__filter-screen {
  overflow: hidden;
}

  .location-app__filter-screen {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .location-app__filter-screen {
  padding: 1rem;
}

  .location-app__filter-screen {
    transition: max-height 0.75s ease;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    bottom: 60px;
  }

  .location-app__filter-screen__close-icon {
  width: 1.5rem;
}

  .location-app__filter-screen--hidden {
  visibility: hidden;
}

  .location-app__filter-screen--hidden {
      max-height: 0;
    }

  @media (min-width: 1024px) {

  .location-app__filter-screen--hidden {
    position: absolute;
  }
}

  @media (min-width: 1024px) {
      .location-app__filter-screen--hidden {
        max-height: 100vh;
      }
    }
`;